module.exports = __webpack_public_path__ + "img/logo.98db5f5d.png";